

import { Box, Stack, Text, Loader } from '@mantine/core';
import SimulatorNodeRenderer from './SimulatorNodeRenderer';

interface Props {
  currentNode: any;
  input: Record<string, any>;
  onInputChange: (input: Record<string, any>) => void;
  onAdvance: (branchTarget?: string) => void;
  onBack?: () => void;
  isAdvancing: boolean;
  completed: boolean;
  onReset: () => void;
  sessionState?: Record<string, any>;
  sessionId?: string | null;
  mode?: 'preview' | 'live';
}

export default function SimulatorCurrentNode({
  currentNode,
  input,
  onInputChange,
  onAdvance,
  onBack,
  isAdvancing,
  completed,
  onReset,
  sessionState = {},
  sessionId,
  mode,
}: Props) {
  return (
    <Box
      w="100%"
      p="xl"
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 12,
        border: '1px solid #E4E7ED',
      }}
    >
      {currentNode || completed ? (
        <SimulatorNodeRenderer
          currentNode={currentNode}
          input={input}
          onInputChange={onInputChange}
          onAdvance={onAdvance}
          onBack={onBack}
          isAdvancing={isAdvancing}
          completed={completed}
          onReset={onReset}
          sessionState={sessionState}
          sessionId={sessionId}
          mode={mode}
        />
      ) : (
        <Stack align="center" gap="md" py="xl">
          <Loader size="sm" color="#415A91" />
          <Text size="sm" c="dimmed">
            Loading...
          </Text>
        </Stack>
      )}
    </Box>
  );
}
